// Adapted from https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/positionsticky.js
var stickySupported = function () {
  var el = document.createElement('a');
  el.style.cssText = 'position: sticky; position: -webkit-sticky; position: -moz-sticky; position: -ms-sticky';
  return el.style.position.indexOf('sticky') !== -1;
}();
export var stickySidebarOffset = function stickySidebarOffset(offset) {
  var navBarHeight = document.querySelector('.fixed-top') ? document.querySelector('.fixed-top').clientHeight : 0;
  return stickySupported ? navBarHeight + offset : 0;
};
export default stickySidebarOffset;